import { Injectable } from '@angular/core';
import { setOptions, MbscOptions  } from '@mobiscroll/angular';
import { localeDe } from '@mobiscroll/angular';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
   private themeOptions: Partial<MbscOptions> = {
    locale: localeDe,
    theme: 'ios',
    themeVariant: 'light', 
  };

  isDarkMode: boolean = false;

  constructor() {
    const savedThemeOptions = localStorage.getItem('themeOptions');
    if (savedThemeOptions) {
      this.themeOptions = JSON.parse(savedThemeOptions);
      if(this.themeOptions.themeVariant === 'dark'){
        this.isDarkMode = true;
      }
    }
    this.applyThemeOptions();
    this.toggleDarkBody(this.isDarkMode)
  }

    /**
   * Wendet die aktuellen Theme-Einstellungen global an.
   * Nutzt Mobiscroll setOptions zur UI-Konfiguration.
   */
  applyThemeOptions() {
    setOptions(this.themeOptions);
  }

  /**
   * Schaltet zwischen Light- und Dark-Mode um.
   * Aktualisiert UI, Body-Class und speichert die Einstellung.
   */
  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    this.toggleDarkBody(this.isDarkMode)
    this.themeOptions.themeVariant = this.themeOptions.themeVariant === 'light' ? 'dark' : 'light';
    this.applyThemeOptions();
    this.saveThemeToLocalStorage();
  }

   /**
   * Überschreibt bestehende Theme-Optionen.
   * Wird genutzt, um Theme-Konfiguration dynamisch zu ändern.
   */
  setThemeOptions(options: any) {
    this.themeOptions = { ...this.themeOptions, ...options };
    this.applyThemeOptions();
    this.saveThemeToLocalStorage();
  }

   /**
   * Speichert die aktuellen Theme-Einstellungen im LocalStorage.
   */
  private saveThemeToLocalStorage() {
    localStorage.setItem('themeOptions', JSON.stringify(this.themeOptions));
  }

   /**
   * Wechselt zwischen verschiedenen UI-Theme-Designs
   * (iOS, Material, Windows).
   */
  toggleThemeType() {
    if (this.themeOptions.theme === 'ios') {
      this.themeOptions.theme = 'material';
    } else if (this.themeOptions.theme === 'material') {
      this.themeOptions.theme = 'windows';
    } else {
      this.themeOptions.theme = 'ios';
    }
    this.applyThemeOptions();
    this.saveThemeToLocalStorage();
  }

    /**
   * Fügt oder entfernt die Darkmode-CSS-Klasse im Body.
   * Steuert das globale Darkmode-Layout der Anwendung.
   */
  toggleDarkBody(isDarkMode: boolean) {
    const body = document.body;
    if(!isDarkMode){
      body.classList.remove('darkmode');
    }else{
      body.classList.add('darkmode');
    }
    
    
  }
}

